// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2vSMN","col":"styles_col__3mosU"};